import { useState, useEffect } from "react"
import PropTypes from "prop-types"

import CheckIns from "./CheckIns"
import CheckInsIntegration from "./CheckInsIntegration"

import { getSessions } from "components/admin/CheckInsStations/utils/requests"

const CheckInsDropdownItem = ({
  event,
  apiBaseUrl,
  checkInsBaseUrl,
  assignmentTypes,
  subscribedToCheckIns,
  checkInsSettingsPath,
  isActingAsStaff
}) => {
  const [sessions, setSessions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const signupIntegrationId = event.signupIntegration?.integration_id

  useEffect(() => {
    if (signupIntegrationId) {
      setIsLoading(true)

      const fetchSessions = async () => {
        const sessions = await getSessions(signupIntegrationId)
        setSessions(sessions.data)
      }

      fetchSessions()
      setIsLoading(false)
    }
  }, [signupIntegrationId])

  if (isLoading) {
    return (
      <div className="p-2">
        <div className="mt-4p line p-2">Loading...</div>
      </div>
    )
  }

  return (
    <>
      {!!signupIntegrationId && subscribedToCheckIns ? (
        <CheckInsIntegration sessions={sessions} checkInsSettingsPath={checkInsSettingsPath} />
      ) : (
        <CheckIns
          apiBaseUrl={apiBaseUrl}
          checkInsBaseUrl={checkInsBaseUrl}
          event={event}
          assignmentTypes={assignmentTypes}
          checkInsSettingsPath={checkInsSettingsPath}
          isActingAsStaff={isActingAsStaff}
        />
      )}
    </>
  )
}

CheckInsDropdownItem.propTypes = {
  apiBaseUrl: PropTypes.string,
  checkInsBaseUrl: PropTypes.string,
  event: PropTypes.shape({
    signupIntegration: PropTypes.shape({
      integration_id: PropTypes.string,
      id: PropTypes.string
    }),
    id: PropTypes.string
  }),
  assignmentTypes: PropTypes.array,
  subscribedToCheckIns: PropTypes.bool,
  isActingAsStaff: PropTypes.bool,
  checkInsSettingsPath: PropTypes.string
}

export default CheckInsDropdownItem
